import React from 'react';
import { Link } from 'react-router-dom';

import Image from '../../assets/img/service/service-1-1.jpg';

const SingleService = (props) => {
  const {
    itemClass,
    categoryClass,
    category,
    thumbClass,
    serviceImage,
    contentClass,
    title,
    description,
    isContentFirst,
  } = props;

  return (
    <div className={itemClass ? itemClass : 'it-service-item'}>
      <div
        className={categoryClass ? categoryClass : 'it-service-category mb-30'}
      >
        <span>{category ? category : 'Mental Health'}</span>
      </div>

      {!isContentFirst ? (
        <>
          <div className={thumbClass ? thumbClass : 'it-service-thumb mb-25'}>
            <img src={serviceImage ? serviceImage : Image} alt="" />
          </div>
          <div className={contentClass ? contentClass : 'it-service-content'}>
            <h4 className="it-service-title mb-15">
              <Link className="hover-anim" to="/service-details">
                {title ? title : ' Nutritional Therapy Services'}
              </Link>
            </h4>
            <p className="mb-0">
              {description
                ? description
                : ' Health and medical is a encompasses a wide range of topics related to health'}
            </p>
          </div>
        </>
      ) : (
        <>
          <div className={contentClass ? contentClass : 'it-service-content'}>
            <h4 className="it-service-title mb-15">
              <Link className="hover-anim" to="/service-details">
                {title ? title : ' Nutritional Therapy Services'}
              </Link>
            </h4>
            <p className="mb-0">
              {description
                ? description
                : ' Health and medical is a encompasses a wide range of topics related to health'}
            </p>
          </div>
          <div className={thumbClass ? thumbClass : 'it-service-thumb mb-25'}>
            <img src={serviceImage ? serviceImage : Image} alt="" />
          </div>
        </>
      )}
    </div>
  );
};

export default SingleService;
